// app\customs\waitingspinner\index.tsx

"use client";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

interface WaitingSpinnerProps {
  message?: string;
}

/**
 * 全画面 Waiting スピナー
 * - 表示制御は親コンポーネントで行う
 * - message が無い場合は描画しない
 */
const WaitingSpinner: React.FC<WaitingSpinnerProps> = ({ message }) => {
  if (!message) return null;

  return ReactDOM.createPortal(
    <div className="waiting-overlay">
      <div className="waiting-spinner" />
      <div className="waiting-text">{message}</div>
    </div>,
    document.body

        // ReactDOM.createPortal(
        //   <div className="global-overlay">
        //     <div className="global-spinner" />
        //     <div className="global-text">相談支援プランを生成しています…</div>
        //   </div>,
        //   document.body // ← body 直下に描画
        // )

  );


};

export default WaitingSpinner;
